import { credibilityLabel } from '../lib/format'

/**
 * The site's running joke, rendered as a real widget: every theory carries a
 * 0–100 rating. Hue is derived from the score so the bar reads at a glance.
 */
export function CredibilityMeter({
  score,
  size = 'default',
}: {
  score: number
  size?: 'default' | 'compact'
}) {
  const clamped = Math.min(100, Math.max(0, score))
  // 0 → red, 100 → green, straight through amber in the middle.
  const hue = Math.round((clamped / 100) * 120)

  return (
    <div className={`credibility credibility-${size}`}>
      <div className="credibility-head">
        <span className="eyebrow">Credibility</span>
        <span className="credibility-score mono" style={{ color: `oklch(0.75 0.15 ${hue})` }}>
          {clamped}/100
        </span>
      </div>
      <div
        className="credibility-bar"
        role="meter"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={`${clamped} out of 100 — ${credibilityLabel(clamped)}`}
      >
        <div
          className="credibility-fill"
          style={{ width: `${clamped}%`, background: `oklch(0.72 0.16 ${hue})` }}
        />
      </div>
      {size === 'default' && <p className="credibility-label">{credibilityLabel(clamped)}</p>}
    </div>
  )
}
